var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9062 5.6842C18.3649 5.6842 19.7639 6.26367 20.7953 7.29512C21.8268 8.32657 22.4062 9.72551 22.4062 11.1842C22.4062 12.6429 21.8268 14.0418 20.7953 15.0733C19.7639 16.1047 18.3649 16.6842 16.9062 16.6842C15.4476 16.6842 14.0486 16.1047 13.0172 15.0733C11.9857 14.0418 11.4062 12.6429 11.4062 11.1842C11.4062 9.72551 11.9857 8.32657 13.0172 7.29512C14.0486 6.26367 15.4476 5.6842 16.9062 5.6842ZM16.9062 8.4342C16.1769 8.4342 15.4774 8.72394 14.9617 9.23966C14.446 9.75539 14.1562 10.4549 14.1562 11.1842C14.1562 11.9135 14.446 12.613 14.9617 13.1287C15.4774 13.6445 16.1769 13.9342 16.9062 13.9342C17.6356 13.9342 18.3351 13.6445 18.8508 13.1287C19.3665 12.613 19.6562 11.9135 19.6562 11.1842C19.6562 10.4549 19.3665 9.75539 18.8508 9.23966C18.3351 8.72394 17.6356 8.4342 16.9062 8.4342ZM16.9062 18.0592C20.5775 18.0592 27.9062 19.888 27.9062 23.5592V27.6842H5.90625V23.5592C5.90625 19.888 13.235 18.0592 16.9062 18.0592ZM16.9062 20.6717C12.8225 20.6717 8.51875 22.6792 8.51875 23.5592V25.0717H25.2938V23.5592C25.2938 22.6792 20.99 20.6717 16.9062 20.6717Z",
    fill: "#3D64E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingProfile);
export default __webpack_public_path__ + "static/media/setting_profile.0d9003e8ce9b3706994a1c1a3d734396.svg";
export { ForwardRef as ReactComponent };